import { useAtomValue } from 'jotai';

import { useMergedCorridors } from '@blocks';
import { Unit, simpleConvert } from '@core';
import { UserPreferredUnit } from '@data';
import { userSettingsAtom, uiNodeBySmpIdAtom } from '@store';

const checkIsWithinCorridors = (
    value: number,
    userPreferredUnit: UserPreferredUnit,
    unit: Unit,
    corridors: { max: number; min: number },
) => {
    const displayValue = simpleConvert({
        value,
        userPreferredUnit,
        unit,
    });
    return displayValue >= corridors.min && displayValue <= corridors.max;
};

export const useParameterRegistration = (parameterId: number, values: number[]) => {
    const mergedCorridors = useMergedCorridors();
    const userSettings = useAtomValue(userSettingsAtom);
    const uiParameterMap = useAtomValue(uiNodeBySmpIdAtom);

    const uiNode = uiParameterMap[parameterId];
    if (!uiNode) {
        return null;
    }

    const corridors = mergedCorridors[uiNode.parameter.smpId];
    if (!corridors) {
        return null;
    }
    const value = values.at(-1);

    if (typeof value === 'undefined') {
        return null;
    }

    const unit = uiNode.parameter?.unit as Unit;

    const displayValue = simpleConvert({
        value,
        userPreferredUnit: userSettings.userPreferredUnit,
        unit,
    });
    return {
        displayValue,
        isWithinCorridors: checkIsWithinCorridors(value, userSettings.userPreferredUnit, unit, corridors),
        hitRate: values.filter((entry) =>
            checkIsWithinCorridors(entry, userSettings.userPreferredUnit, unit, corridors),
        ).length,
        totalCount: values.length,
        corridors,
        uiNode,
    };
};
